<template>
    <be-form-group :focus="hasFocus" v-bind="widgetProps">
        <input
            ref="el"
            :id="name"
            :name="name"
            :type="typeValue"
            :placeholder="placeholderValue"
            :required="required"
            :minlength="minlength || validationProp('minLength', 'min')"
            :maxlength="maxlength || validationProp('maxLength', 'max')"
            :min="min"
            :max="max"
            :disabled="disabled"
            :autocomplete="autocomplete"
            :autofocus="autofocus"
            :value="value"
            :class="widgetClass"
            @input="$emit('input', $event.target.value)"
            @change="$emit('change', $event.target.value)"
            @focus="onFocus"
            @blur="onBlur"
        >
        <template slot="after">
            <slot/>
        </template>
    </be-form-group>
</template>

<script>
    import widget from '../../mixins/widget';

    export default {
        mixins: [widget],

        props: {
            type: String,
            placeholder: String,
            autocomplete: String,
            minlength: Number,
            maxlength: Number,
            min: Number,
            max: Number,
        },

        computed: {
            typeValue() {
                if (this.type) {
                    return this.type;
                }

                if (this.validationFor('url')) {
                    return 'url';
                }

                if (this.validationFor('numeric')) {
                    return 'number';
                }

                if (this.validationFor('email') || this.validationFor('username')) {
                    return 'email';
                }

                if (this.validationFor('phone')) {
                    return 'tel';
                }

                if (this.validationFor('password')) {
                    return 'password';
                }

                return 'text';
            },

            placeholderValue() {
                if (this.placeholder) {
                    return this.placeholder;
                }

                if (this.validationFor('url')) {
                    return 'https://www.example.com';
                }

                if (this.validationFor('phone')) {
                    return '+41 00 000 00 00';
                }

                return '';
            },
        },
    };
</script>
